import React from "react";
const IconGoBack = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="15.34"
    viewBox="0 0 17 15.34"
  >
    <path
      id="Path"
      d="M16.585,6.668,9.917,0l-2,2,4.25,4.25H0V9.087H12.163l-4.25,4.25,2,2,6.668-6.668A1.417,1.417,0,0,0,16.585,6.668Z"
      fill="#565656"
    />
  </svg>
);
export default IconGoBack;
